<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="BaPenalty"></IndexBase>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] BA Penalty
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL 
                        && header.Status != this.$APPROVAL_STATUS.APPROVED && header.Status != this.$APPROVAL_STATUS.REVISED && header.Status != this.$APPROVAL_STATUS.DONE)"/>
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && !onlyDraft" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">

                            <FormField :labelName="$t('company_contractor')" fieldName="Contractor_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Contractor_Code" :filter="true"  v-if="header"
                                    v-model="header.Contractor_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/contractor_code'"
                                    :minLength="0"
                                    :params="{ docDate: (this.header.Hari_Tgl_Input != null ? this.header.Hari_Tgl_Input : null)}"  
                                    :disabled="true"/>
                                    <small v-if="header && !header.Contractor_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('company_contractor')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('doc_no')" fieldName="Doc_No" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Doc_No" v-model="header.Doc_No" required="true" type="text"
                                    :placeholder="$t('doc_no')" v-if="header"
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('doc_date')" fieldName="Hari_Tgl_Input" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="doc_date" v-model="header.Hari_Tgl_Input" type="text"
                                :placeholder="$t('doc_date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                <small
                                    v-if="header && !header.Hari_Tgl_Input && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('doc_date')) }}
                                </small>
                            </FormField>
                            
                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                    :placeholder="$t('reason')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    <small v-if="header && !header.Reason && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                    </small>
                            </FormField>


                            <FormField :labelName="$t('penalty_days')" fieldName="Penalty_Days" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Penalty_Percentage" v-model="header.Penalty_Days" required="true" type="text"
                                    :placeholder="$t('penalty_days')" v-if="header" :useGrouping="false"
                                    :disabled="true" :min="0"/>
                                    <small v-if="header && !header.Penalty_Days && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('penalty_days')) }}
                                    </small>
                            </FormField>

                            <FormField :labelName="$t('penalty_percentage')" fieldName="Penalty_Percentage" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Penalty_Percentage" v-model="header.Penalty_Percentage" required="true" type="text"
                                    :placeholder="$t('penalty_percentage')" v-if="header" :useGrouping="false" @input="changePercentage($event)"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" :min="0" :max="100"/>
                                    <small v-if="header && !header.Penalty_Percentage && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('penalty_percentage')) }}
                                    </small>
                            </FormField>
                            
                            <FormField :labelName="$t('total_penalty_value')" fieldName="Total_Penalty_Value" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Total_Penalty_Value" v-model="header.Total_Penalty_Value" required="true" type="text"
                                    :placeholder="$t('total_penalty_value')" v-if="header"
                                    :disabled="true" :useGrouping="true" :maxFractionDigits="2" :minFractionDigits="2"/>
                                    <small v-if="header && !header.Total_Penalty_Value && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('total_penalty_value')) }}
                                    </small>
                            </FormField>
                        </div>  
                        <div class="col-6">
                            
                            <FormField :labelName="$t('status')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Status" v-model="header.Status" required="true" type="text"
                                    :placeholder="$t('status')" v-if="header"
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('max_penalty_value')" fieldName="Max_Penalty_Value" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Max_Penalty_Value" v-model="header.Max_Penalty_Value" required="true" type="text"
                                    :placeholder="$t('max_penalty_value')" v-if="header"
                                    :disabled="true" :useGrouping="true" :maxFractionDigits="2" :minFractionDigits="2"/>
                                    <small v-if="header && !header.Max_Penalty_Value && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('max_penalty_value')) }}
                                    </small>
                            </FormField>

                            <FormField :labelName="$t('total_penalty_charged')" fieldName="Total_Penalty_Charged" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Total_Penalty_Charged" v-model="this.TotalPenaltyCharged" required="true" type="text"
                                    :placeholder="$t('total_penalty_charged')" v-if="header"
                                    :disabled="true" :useGrouping="true" :maxFractionDigits="2" :minFractionDigits="2"/>
                                    <small v-if="header && !header.Total_Penalty_Charged && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('total_penalty_charged')) }}
                                    </small>
                            </FormField>

                            <FormField :labelName="$t(labelAppr1)" fieldName="Username_CP_PM" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr1">
                                <CustomSelect name="Username_CP_PM" :filter="true"  v-if="header"
                                    v-model="header.Username_CP_PM" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As1,user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.PENALTY, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_CP_PM && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr1)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t(labelAppr2)" fieldName="Username_PC" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr2">
                                <CustomSelect name="Username_PC" :filter="true"  v-if="header"
                                    v-model="header.Username_PC" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As2,user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.PENALTY, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_PC && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr2)) }}
                                </small>
                            </FormField>
                        
                            <FormField :labelName="$t('Reason_Edit')" fieldName="Reason_Edit" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (header.Status == this.$APPROVAL_STATUS.DONE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL)">
                                <InputText name="Reason_Edit" v-model="header.Reason_Edit" required="true" type="text"
                                    :placeholder="$t('Reason_Edit')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT|| header.Status != this.$APPROVAL_STATUS.DONE"/>
                                    <small v-if="header &&((!header.Reason_Edit && header.Status == this.$APPROVAL_STATUS.DONE)) && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('Reason_Edit')) }}
                                    </small>
                            </FormField>
                        
                        </div>
                        <div class="col-12">
                            <DataTable v-if="header" :loading="!header" :value="header.Details ? header.Details : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">

                                <Column field="Judul_Pekerjaan" :header="$t('job_title')" Key="Id" style="width:200px;">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('job_title')" @change="onCellEditComplete(slotProps)"
                                                :disabled="true"
                                                v-show="slotProps.data.mode != 'Delete'" :readonly="true"/>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="SPO" :header="$t('spo')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('spo')" @change="onCellEditComplete(slotProps)"
                                                :disabled="true"
                                                v-show="slotProps.data.mode != 'Delete'" :readonly="true"/>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Nilai_Kontrak" :header="$t('contract_value')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputNumber
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true" :useGrouping="true" :maxFractionDigits="2" :minFractionDigits="2"
                                                :placeholder="$t('contract_value')" @change="onCellEditComplete(slotProps)"
                                                :disabled="true"
                                                v-show="slotProps.data.mode != 'Delete'" :readonly="true"/>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Sch_Date" :header="$t('sch_date')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <DatePicker name="Sch_Date" v-model="slotProps.data[slotProps.column.props.field]"
                                            :placeholder="$t('sch_date')" @input="onCellEditComplete(slotProps)" @date-select="onCellEditComplete(slotProps)"
                                            :disabled="true"
                                            v-show="slotProps.data.mode != 'Delete'"/>
                                        
                                            <small v-if="!slotProps.data.Sch_Date && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('sch_date')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Act_Date" :header="$t('act_date')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <DatePicker name="Act_Date" v-model="slotProps.data[slotProps.column.props.field]"
                                            :placeholder="$t('act_date')" @input="onCellEditComplete(slotProps)" @date-select="onCellEditComplete(slotProps);onSelectDate1($event, slotProps.data)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'"/>
                                        
                                            <small v-if="!slotProps.data.Act_Date && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('act_date')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Total_Days" :header="$t('total_days')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputNumber name="Total_Days" v-model="slotProps.data[slotProps.column.props.field]"
                                            :placeholder="$t('total_days')" @input="onCellEditComplete(slotProps)" :useGrouping="false"
                                            :disabled="true"
                                            v-show="slotProps.data.mode != 'Delete'" :readonly="true" /> <br/>
                                            <small v-if="!slotProps.data.Total_Days && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('total_days')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>

                            </DataTable>
                        </div>
                      
                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('release_approval')">
                                    <ChangeHistory angeHistory v-if="this.header" :modelValue="this.dataModelRelease"
                                        :dataRequestLog="this.dataRelease" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
import IndexBase from '../Helper/IndexBase.vue'
export default {
    name: "Editor",
    components: {
        IndexBase
    },
    data() {
        return {
            indexName: "BaPenaltyIndex",
            url: this.$API_URL + "bapenalty/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            mainid : 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataModelRelease: [],
            dataRelease: this.$dataRelease,
            viewFiles : null,
            detailLog : null,
            dataChangesLog:this.$dataChangesLog,
            labelAppr1 : "",
            labelAppr2 : "",
            submitted2 : false,
            onlyDraft: false,
        }
    },
    methods: {
        changePercentage(e){
            let value = e.value;
            //let penalty_days = this.header.Details[0].Penalty_Days;
            if(value != null){
                if(value > 100){
                    value = 100;
                }
            }

        },
        onAuth(event) {
            this.onlyDraft = event.onlyDraft;
        },
        onSelectDate1(e,data){
            if(data.Sch_Date !=null){
                var date1 =  new Date(e);
                var date2 = new Date(data.Sch_Date);

                if(this.$isNotWIB){        
                    //date1 = new Date(new Date(e).setHours(new Date(e).getHours() + this.$store.getters.getAddHoursGMT));
                    date1.setHours(0, 0, 0, 0);
                    //date2 = new Date(new Date(data.Sch_Date).setHours(new Date(data.Sch_Date).getHours() + this.$store.getters.getAddHoursGMT));
                    date2.setHours(0, 0, 0, 0);
                }

                var cekDate = date1 < date2;

                if(cekDate){
                    this.showError("Error", 'Act Date is smaller than Sch Date');
                    data.Act_Date = null;
                    data.Total_Days = null;
                }else{
                    var total_hari =  date1 - date2;
                    data.Total_Days = total_hari / (1000 * 60 * 60 * 24);
                }
            }
        },
        getData() {
            var self = this;
            this.$axios.get(this.url + this.mainid + "/" +this.id + "/" + this.mode)
                .then((response) => {

                    if(!response.data.success){
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });   
                        return;
                    }

                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.detail = response.data.data.detail;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.dataModelRelease = response.data.data.header.approval_log;
                    self.detailLog = self.header.DetailLog;
                    if(self.mode ==  self.$FORM_MODE_CREATE || self.mode ==  self.$FORM_MODE_EDIT){
                        self.header.Max_Penalty_Value = (5/100) * self.header.contract_value;
                    }
                    

                    var listAppr = response.data.data.listPicAppr;
                    if(listAppr.length > 0)
                    {
                        listAppr.forEach(a=>{
                            if(a.Sign_Position == 1){
                                self.labelAppr1 = a.Approval_As;
                                self.header.Appr_As1 = a.Approval_As;
                                self.header.Sign_Position1 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 2){
                                self.labelAppr2 = a.Approval_As;
                                self.header.Appr_As2 = a.Approval_As;
                                self.header.Sign_Position2 =  a.Sign_Position;
                            }
                        });
                    }

                })
                .catch(function (error) {
                    self.showError("Error", error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;

            this.header.Jumlah_Hari_Keterlambatan = this.DayOfDelay;
            this.header.Jumlah_Hari = this.Number_of_Days;

            if(this.header){        
                this.header.Hari_Tgl_Input_String = this.$moment(this.header.Hari_Tgl_Input).format('YYYY/MM/DD').toString()
                
                this.header.Details.forEach(a=>{
                    if(a.Act_Date){
                        var date = new Date(a.Act_Date);
                        a.Act_Date_String =  this.$moment(date).format('YYYY/MM/DD').toString()
                    }

                    if(a.Sch_Date){
                        var date = new Date(a.Sch_Date);
                        a.Sch_Date_String =   this.$moment(date).format('YYYY/MM/DD').toString()
                    }
                });    
            }
            
             this.$axios.post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: "BA Penalty has been deleted successfully", life: 3000 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "BA Penalty has been saved successfully", life: 3000 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
            else 
              this.$router.push({ path: "Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            this.submitted2 = true;
            var self = this;
            var is_required = false;
            this.header.Total_Penalty_Charged = this.TotalPenaltyCharged;
            //|| !this.header.Date_Place 
            //|| !this.header.Username_CP_PM|| !this.header.Dikeluarkan_Oleh !this.header.Nilai_Denda || (!this.header.Lampiran  || this.header.Lampiran < 0)|||| !this.header.Perihal || 
            
            if(self.mode != this.$FORM_MODE_DELETE){

                if (!this.header.Hari_Tgl_Input ||
                   (this.labelAppr1 && !this.header.Username_CP_PM) || (this.labelAppr2 && !this.header.Username_PC) || !this.header.Reason || !this.header.Penalty_Percentage || 
                    !this.header.Total_Penalty_Value || !this.header.Max_Penalty_Value || !this.header.Total_Penalty_Charged || (!this.header.Penalty_Days)
                    ||(!this.header.Reason_Edit && this.header.Status == this.$APPROVAL_STATUS.DONE)) {
                    return;
                }
    
                this.header.Details.forEach(a => {
                    if(a.Act_Date == null || a.Total_Days == null){
                        is_required=true;
                    }
                });
    
                if(is_required){
                    return
                }
           
                if(this.header.Details.length == 0){
                    self.showError("Error", "Must have one detail")
                    return;
                }

            }
           

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        confirmDraft(event) {
            this.submitted = true;
            this.submitted2 = false;
            var self = this;

            var is_required = false;
            this.header.Total_Penalty_Charged = this.TotalPenaltyCharged;
            //|| !this.header.Date_Place 
            //|| !this.header.Username_CP_PM || !this.header.Dikeluarkan_Oleh !this.header.Nilai_Denda || || !this.header.Perihal || (!this.header.Lampiran  || this.header.Lampiran < 0) ||
            if (!this.header.Hari_Tgl_Input ||
                !this.header.Reason || !this.header.Penalty_Percentage || 
                !this.header.Total_Penalty_Value || !this.header.Max_Penalty_Value || !this.header.Total_Penalty_Charged ||  (!this.header.Penalty_Days)) {
                return;
            }

            // this.header.Details.forEach(a => {
            //     if(a.Act_Date == null || a.Total_Days == null){
            //         is_required=true;
            //     }
            // });

            // if(is_required){
            //     return
            // }

            if(this.header.Details.length == 0){
                self.showError("Error", "Must have one detail")
                return;
            }

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                        this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.detail;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Details.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.header.Details[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Details.splice(this.header.Details.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.header && this.header.Details) {
                let mode = this.header.Details[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Details[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        onFileRemove(files,data) {
                data.files_data = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelect(event, data) {
                data.files_data = [];
                for(var i = 0; i<event.files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelectUpload(event) {
            this.detailFiles = event.files;
            this.uploadFile = true;
        },
        onDownloadFile(file){
            var self = this;
            this.$axios.get(this.url + "download_attachment/" + file.id + "/" + file.name, {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);
                    document.body.appendChild(link);
                    link.click();
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    //self.showAssignModal = false;
                });
        },
    },
    computed:{
        TotalPenaltyCharged(){
            var result = 0;
            let percentage_value = this.header.Penalty_Percentage;
            if(percentage_value != null){
                if(percentage_value > 100){
                    percentage_value = 100;
                }

                if(this.header.Penalty_Days != null){
                   if(this.header.contract_value == null)
                        this.header.contract_value = this.header.Details[0].Nilai_Kontrak;

                    this.header.Total_Penalty_Value = (percentage_value/1000) * this.header.contract_value * this.header.Penalty_Days; 
                }
            }

            if(percentage_value == null || this.header.Penalty_Days == null){
                this.header.Total_Penalty_Value = null;
            }
            
            if(this.header.Max_Penalty_Value < this.header.Total_Penalty_Value)
                result = this.header.Max_Penalty_Value;
            else if(this.header.Max_Penalty_Value > this.header.Total_Penalty_Value) 
                result = this.header.Total_Penalty_Value;
            else
                result = this.header.Total_Penalty_Value;
            
            return result;
        },
        DayOfDelay(){
            var endDate = new Date(this.header.Tanggal_Final);
            var startDate = new Date(this.header.Tanggal_Selesai);
        
            if(this.$isNotWIB){    
                endDate.setHours(0, 0, 0, 0);
                startDate.setHours(0, 0, 0, 0);
            }
            
            const differenceMs = endDate - startDate;
            var result = Math.floor(differenceMs / (1000 * 60 * 60 * 24))

            // if(this.header.Tanggal_Final == null && this.header.Tanggal_Selesai == null)
            //     result = 0;
                
            return result;
        },
        Number_of_Days(){
            var result = 0;
            var arrData = this.header.Details.filter(a=> a.mode != this.$FORM_MODE_DELETE);
            if(arrData.length != 0){

                arrData.forEach(a => {
                    var startDate = new Date(a.Tanggal_Mulai);
                    var endDate = new Date(a.Tanggal_Selesai);
                    
                    if(this.$isNotWIB){    
                        startDate.setHours(0, 0, 0, 0);
                        endDate.setHours(0, 0, 0, 0);
                    }

                    // if(a.Tanggal_Selesai == null)
                    //     endDate = 0;
                        
                    var differenceMs = endDate - startDate;
                    var hasil = Math.floor(differenceMs / (1000 * 60 * 60 * 24));

                    a.Hari = hasil;

                    // if(a.Tanggal_Mulai == null && a.Tanggal_Selesai == null)
                    //     a.Hari = 0;
                    
                   
                    result+= hasil; 
                
                });
            }
           
            return result;
        }
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
        this.mainid = this.$route.query.mainid ?? 0;
        this.getData();
        if(this.$router.options.history.state.back != null){
            var indexName = this.$router.options.history.state.back.split("/");
            if(indexName[1] == "MainData")
                this.indexName = "MainDataIndex";
        }
    
    }
}
</script>